module.exports = __webpack_public_path__ + "static/money-bb48b283eff8be2be8bbebb3f6376c3b.jpg";